<div class="ext-pitch-content" [class.hidden]="loading$ | async">
  <ng-container *ngIf="pitch$ | async as pitch">
    <pitch-header [pitch]="pitch" [userDivision]="pitch.userDivision"></pitch-header>
  </ng-container>

  <ng-container *ngIf="pitchNotFound$ | async">
    <h2 class="text-center margintop20">Pitch not found</h2>
  </ng-container>

  <router-outlet></router-outlet>
</div>

<pitch-footer [class.hidden]="loading$ | async" [userDivision]="(pitch$ | async)?.userDivision"> </pitch-footer>
<app-feature-flag-widget></app-feature-flag-widget>
